import { React, useState, useEffect, Fragment } from "react";
import { useShowController, SimpleShowLayout, TextField, EmailField, useDataProvider } from 'react-admin';
import {
    Snackbar, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, IconButton, Grid, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box, Chip, Stack, Tooltip, Typography
} from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import DownloadIcon from '@mui/icons-material/Download';
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import { TotalProcessingBill } from "./TotalProcessingBill";
import ResiliationLetter from "../../Components/Letter/resiliationletter";
import { downloadPdf, generateBase64Pdf } from "../../Components/Utils/PdfDownloader";
import SendingDetailsDialog from "./SendingDetails";
import { getProviderName } from "../../Utils/providerUtils";

const MyShow = props => {

    const dataProvider = useDataProvider();

    const {
        // basePath, // deduced from the location, useful for action buttons
        // defaultTitle, // the translated title based on the resource, e.g. 'Post #123'
        // loaded, // boolean that is false until the record is available
        // loading, // boolean that is true on mount, and false once the record was fetched
        record, // record fetched via dataProvider.getOne() based on the id from the location
        // resource, // the resource name, deduced from the location. e.g. 'posts'
        // version, // integer used by the refresh feature
    } = useShowController(props);

    const [open, setOpen] = useState(false);

    const [currentPaymentToConfirm, setCurrentPaymentToConfirm] = useState({});
    const [openTpDialog, setOpenTpDialog] = useState(false);
    const [openResendDialog, setOpenResendDialog] = useState(false);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [mailingToDetail, setMailingToDetail] = useState();


    const [snackContent, setSnackContent] = useState('');

    const [mailingToResend, setMailingToResend] = useState();

    const [invoices, setInvoices] = useState([]);
    const [alerts, setAlerts] = useState([]);
    const [totalProcessingPayments, setTotalProcessingPayments] = useState([]);

    const [mailings, setMailings] = useState([]);

    useEffect(() => {
        const invoices = record?.invoices?.sort((a, b) => new Date(b.date) - new Date(a.date));
        setInvoices(invoices ? invoices : []);
        const alerts = record?.alerts?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setAlerts(alerts ? alerts : []);

        const mailingsTmp = record?.mailings;
        if (mailingsTmp != null && mailingsTmp !== undefined && mailingsTmp.length > 0) {
            mailingsTmp.forEach((m) => {
                m.type = m.resiliationModel ? "MyResil" : "LREL";
                m.credit = m.resiliationModel ? 1 : m.contacts.length;
            });
            setMailings(record?.mailings)
        }
    }, [record]);

    useEffect(() => {
        const tpPayments = record?.totalProcessingPayments?.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        setTotalProcessingPayments(tpPayments ? tpPayments : []);
    }, [record]);


    const downloadTotalProcessingInvoice = (id) => {
        console.log("Donwload")
        const html2pdf = require('html2pdf.js');

        const element = document.getElementById("tpinvoice-" + id);

        html2pdf().from(element).set({
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                dpi: 192,
                scale: 5,
                letterRendering: true,
                useCORS: true
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            margin: [0, 0, 0, 0],
        }).toPdf().save("Facture-" + id + ".pdf");
    }

    const openSnackBar = (content) => {
        setSnackContent(content);
        setOpen(true);
    };

    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        setSnackContent("");
    };

    const getSubscriptionStatus = (statusNumber) => {
        switch (statusNumber) {
            case 0:
                return "Essai";
            case 1:
                return "En cours";
            case 2:
                return "Retard de paiement";
            case 3:
                return "Annulé par opérateur";
            case 4:
                return "Annulé pour retard de paiement";
            case 5:
                return "Annulé par le client";
            default:
                return statusNumber;
        }
    }

    const revokeSubscription = () => {
        dataProvider.getCustom('Subscription/Revoke', { id: record.subscriptionTotalProcessing.id })
            .then((data) => {
                if (data.reason) {
                    openSnackBar('Erreur lors de la révoquation de la soucription ' + data.message);
                } else {
                    openSnackBar('Souscription révoquée et email de confirmation envoyé au client.');
                }
            })
            .catch((e) => {
                openSnackBar('Erreur lors de la révoquation de la soucription ' + e);

            });
    }

    const resendPassword = () => {
        dataProvider.getCustom(`Admin/ResetPassword?email=${record.email}`)
            .then(({ data }) => {
                openSnackBar(`Le nouveau mot de passe a été envoyé à ${record.email}`);
            })
            .catch((e) => {
                openSnackBar('Erreur lors de l\'envoi du nouveau mot de passe ' + e);

            });
    }

    function getTPStatusName(code) {
        switch (code) {
            case 'DB':
                return 'Payée';
            case 'RF':
                return 'Remboursée';
            default:
                return code;
        }
    }
    const handleOpenTpDialog = (paymentItem) => {
        setCurrentPaymentToConfirm(paymentItem);
        setOpenTpDialog(true);
    };

    const handleCloseTpDialog = () => {
        setOpenTpDialog(false);
    };

    const handleCloseResendDialog = () => {
        setOpenResendDialog(false);
    };


    const confirmRefillPaymentTpp = (paymentItem) => {
        refillPaymentTp(paymentItem, record.id);
        handleCloseTpDialog();
    }

    function getDepositProof(contactId) {

        dataProvider.getFile(`Mailing/Admin/Contact/${contactId}/DepositProof`).then((data) => {
            console.log(data)
            const file = new Blob([data.body], { type: 'application/pdf' });

            // process to auto download it
            const fileURL = URL.createObjectURL(file);
            const link = window.document.createElement('a');
            link.href = fileURL;
            link.download = "Preuve de dépôt.pdf";
            link.click()
        })
    }

    function getMyResilDocument(contactId) {
        dataProvider.getFile(`Mailing/Admin/Contact/${contactId}/SendDocument`).then((data) => {
            console.log(data)
            const file = new Blob([data.body], { type: 'application/pdf' });

            // process to auto download it
            const fileURL = URL.createObjectURL(file);
            const link = window.document.createElement('a');
            link.href = fileURL;
            link.download = "Document " + contactId + ".pdf";
            link.click()
        })
    }

    const refillPaymentTp = (paymentItem, clientId) => {
        dataProvider.postCustom(`Subscription/Refund/${clientId}`, paymentItem)
            .then((data) => {
                console.log(data)
                if (data.reason) {
                    openSnackBar('Erreur lors du remboursement ' + data.reason);
                } else {
                    openSnackBar('Remboursement effectué avec succès');
                }

            })
            .catch((e) => {
                console.log(e)
                openSnackBar('Erreur lors du remboursement ' + e.reason);
            });
    }

    const resendDocument = async (mailingId, containerId) => {
        const mailing = {
            id: mailingId
        };
        const document = await generateBase64Pdf(containerId);
        mailing.Base64Document = document;
        dataProvider.postCustom('Admin/Mailing/Resend', mailing)
            .then((data) => {
                console.log(data)
                handleCloseResendDialog();
                if (data.reason) {
                    openSnackBar('Erreur lors du renvoi ' + data.reason);
                } else {
                    openSnackBar('Renvoi réussi');
                }

            })
            .catch((e) => {
                console.log(e)
                openSnackBar('Erreur lors du renvoi ' + e.reason);
            });
    }



    return (
        <div>
            <h1>{record?.uid}</h1>

            <h2>Détails de l'abonnement</h2>
            <Grid container direction="row">
                <Grid item xs={6} container direction="column">
                    <Grid item>Nom : {record?.name}</Grid>
                    <Grid item>Client : {record?.email}</Grid>
                    <Grid item>Téléphone : {record?.phoneNumber}</Grid>
                    <Grid item>
                        Adresse : {record?.address} {record?.address ? "," : ""}{" "}
                        {record?.postalCode} {record?.city}
                    </Grid>
                    <Grid item>
                        Crée le :{" "}
                        {record && record.createdAt
                            ? new Date(record.createdAt + "Z").toLocaleString()
                            : ""}
                    </Grid>
                    
                    {record?.subscriptionTotalProcessing?.status !== "review" &&
                        record?.subscriptionTotalProcessing?.status !== "active" &&
                        record?.subscriptionTotalProcessing?.status !== "trialing" &&
                        record?.subscriptionTotalProcessing?.status !== "latePayment" && (
                            <Grid item>
                                Désinscris le :{" "}
                                {record && record?.subscriptionTotalProcessing?.periodEnd
                                    ? new Date(
                                        record?.subscriptionTotalProcessing?.periodEnd + "Z"
                                    ).toLocaleString()
                                    : ""}
                            </Grid>
                        )}
                    <Grid item>ID : {record?.id}</Grid>
                    <Grid item>
                        Statut :{" "}
                        <strong>
                            {getSubscriptionStatus(
                                record?.subscriptionTotalProcessing?.status
                            )}
                        </strong>
                    </Grid>
                    <Grid item>Provider de paiement : {getProviderName(record?.subscriptionTotalProcessing?.provider)}</Grid>
                    <br />
                    <br />
                    <Grid item>Origin : {record?.origin}</Grid>
                    <Grid item>Referrer : {record?.referrer}</Grid>
                    <Grid item>IP : {record?.ip}</Grid>
                    <Grid item>
                        Crédit LREL : {record?.subscriptionTotalProcessing?.credits}
                    </Grid>
                </Grid>

                <Grid item>
                    {!record?.subscriptionTotalProcessing?.status.startsWith(
                        "canceled"
                    ) ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={revokeSubscription}
                        >
                            Révoquer l'abonnement
                        </Button>
                    ) : (
                        <></>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: "15px" }}
                        onClick={resendPassword}
                    >
                        Renvoyer mot de passe
                    </Button>
                </Grid>
            </Grid>

            {record?.subscriptionTotalProcessing?.periodEnd == null ? (
                <>
                    <h2>Factures à venir</h2>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Date</TableCell>
                                    <TableCell align="center">Qté</TableCell>
                                    <TableCell align="center">Prix unitaire</TableCell>
                                    <TableCell align="center">Montant</TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {record?.subscriptionTotalProcessing ? (
                                    <TableRow>
                                        <TableCell align="center">
                                            {record?.subscriptionTotalProcessing?.periodEnd
                                                ? new Date(
                                                    record?.subscriptionTotalProcessing?.periodEnd +
                                                    "Z"
                                                ).toLocaleString()
                                                : ""}
                                        </TableCell>
                                        <TableCell align="center">1</TableCell>
                                        <TableCell align="center">
                                            {record?.subscriptionTotalProcessing?.amount}
                                        </TableCell>
                                        <TableCell align="center">
                                            {record?.subscriptionTotalProcessing?.amount}
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    <></>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            ) : (
                <></>
            )}
            <h2>Factures</h2>
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Montant</TableCell>
                            <TableCell align="center">Statut</TableCell>
                            <TableCell align="center">Numéro de facture</TableCell>
                            <TableCell align="center">Date du paiement</TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {invoices.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell align="center">{row.amount} €</TableCell>
                                <TableCell align="center">Payée</TableCell>
                                <TableCell align="center">{row.invoiceNumber}</TableCell>
                                <TableCell align="center">
                                    {row.date && new Date(row.date + "Z").toLocaleString()}
                                </TableCell>
                                <TableCell align="center">
                                    <IconButton
                                        color="primary"
                                        component="span"
                                        onClick={() =>
                                            downloadTotalProcessingInvoice(row.invoiceNumber)
                                        }
                                    >
                                        <GetAppIcon />
                                    </IconButton>
                                </TableCell>
                                <Box style={{ display: "none" }}>
                                    <TotalProcessingBill invoice={row} />
                                </Box>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <h2>Transactions</h2>
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Montant</TableCell>
                            <TableCell align="center">Statut</TableCell>
                            <TableCell align="center">Référence du paiement</TableCell>
                            <TableCell align="center">Date du paiement</TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <>
                            {totalProcessingPayments.map((paymentItem, index) => (
                                <TableRow key={index}>
                                    <TableCell align="center">{paymentItem.amount} €</TableCell>
                                    <TableCell align="center">
                                        {getTPStatusName(paymentItem.paymentType)}
                                    </TableCell>
                                    <TableCell align="center">
                                        {paymentItem.paymentType === "RF"
                                            ? paymentItem.referencedId
                                            : paymentItem.id}
                                    </TableCell>
                                    <TableCell align="center">{paymentItem.timestamp ? (paymentItem.timestamp.includes("+") ? new Date(paymentItem.timestamp).toLocaleString() : new Date(paymentItem.timestamp + "Z").toLocaleString()) : ''}</TableCell>
                                    <TableCell align="center">
                                        {paymentItem.paymentType !== "RF" && (
                                            <>
                                                <Button
                                                    color="primary"
                                                    onClick={() => handleOpenTpDialog(paymentItem)}
                                                >
                                                    Rembourser
                                                </Button>
                                                <Dialog
                                                    open={openTpDialog}
                                                    onClose={handleCloseTpDialog}
                                                    aria-labelledby="alert-dialog-title"
                                                    aria-describedby={
                                                        "alert-dialog-description-" + paymentItem.id
                                                    }
                                                >
                                                    <DialogTitle id="alert-dialog-title">
                                                        Remboursement
                                                    </DialogTitle>
                                                    <DialogContent>
                                                        <DialogContentText
                                                            id={
                                                                "alert-dialog-description-" + paymentItem.id
                                                            }
                                                        >
                                                            Êtes vous sur d'effectuer un remboursement de{" "}
                                                            {currentPaymentToConfirm.amount} €
                                                        </DialogContentText>
                                                    </DialogContent>
                                                    <DialogActions>
                                                        <Button
                                                            onClick={handleCloseTpDialog}
                                                            color="primary"
                                                        >
                                                            Annuler
                                                        </Button>
                                                        <Button
                                                            onClick={() =>
                                                                confirmRefillPaymentTpp(
                                                                    currentPaymentToConfirm
                                                                )
                                                            }
                                                            color="primary"
                                                            autoFocus
                                                        >
                                                            Rembourser
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>
                                            </>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </>
                    </TableBody>
                </Table>
            </TableContainer>
            {record?.subscriptionTotalProcessing?.status === "trialing" ||
                record?.subscriptionTotalProcessing?.status === "active" ? (
                <>
                    <h2>Factures à venir</h2>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Date</TableCell>
                                    <TableCell align="center">Qté</TableCell>
                                    <TableCell align="center">Prix unitaire</TableCell>
                                    <TableCell align="center">Montant</TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {record?.subscriptionTotalProcessing ? (
                                    <TableRow>
                                        <TableCell align="center">
                                            {record?.subscriptionTotalProcessing?.periodEnd
                                                ? new Date(
                                                    record?.subscriptionTotalProcessing?.periodEnd +
                                                    "Z"
                                                ).toLocaleString()
                                                : ""}
                                        </TableCell>
                                        <TableCell align="center">1</TableCell>
                                        <TableCell align="center">
                                            {record?.subscriptionTotalProcessing?.amount} €
                                        </TableCell>
                                        <TableCell align="center">
                                            {record?.subscriptionTotalProcessing?.amount}
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    <></>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            ) : (
                <></>
            )}
            {mailings && (
                <Box sx={{ marginBottom: "150px" }}>
                    <h2>Envois</h2>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Date</TableCell>
                                    <TableCell align="center">Status</TableCell>
                                    <TableCell align="center">Type d'envoi</TableCell>
                                    <TableCell align="center">Destinataire</TableCell>
                                    <TableCell align="center">Crédit</TableCell>
                                    <TableCell align="center">Document envoyé</TableCell>
                                    <TableCell align="center">Numéro de suivi</TableCell>
                                    <TableCell align="center">Preuve de dépôt</TableCell>
                                    <TableCell align="center">Détails</TableCell>
                                    <TableCell align="center">Renvoyer</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {mailings.map((mailing, index) => (
                                    <TableRow>
                                        <TableCell align="center">
                                            {mailing?.createdAt
                                                ? new Date(mailing?.createdAt + "Z").toLocaleString()
                                                : ""}
                                        </TableCell>
                                        <TableCell align="center">
                                            <StatusShipment item={mailing} />
                                        </TableCell>
                                        <TableCell align="center">
                                            <TypeShipment item={mailing} />
                                        </TableCell>
                                        <TableCell align="center">
                                            {mailing?.resiliationModel ? (
                                                mailing?.resiliationModel?.name
                                            ) : (
                                                <Stack direction="row">
                                                    {mailing?.contacts?.length > 1 ? (
                                                        <>
                                                            Plusieurs destinataires{" "}
                                                            <TooltipQuestionMark
                                                                tooltip={mailing?.contacts
                                                                    ?.map(
                                                                        (c) => c?.firstName + " " + c?.lastName
                                                                    )
                                                                    .join(", ")}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>
                                                            {mailing?.contacts[0]?.firstName}&nbsp;
                                                            {mailing?.contacts[0]?.lastName}
                                                        </>
                                                    )}
                                                </Stack>
                                            )}
                                        </TableCell>
                                        <TableCell align="center">
                                            {mailing?.credit} LREL
                                        </TableCell>
                                        <TableCell align="center">
                                            {mailing?.contacts && mailing.contacts.length === 1 && (
                                                <IconButton
                                                    onClick={() =>
                                                        getMyResilDocument(
                                                            mailing?.contacts &&
                                                                mailing.contacts.length === 1
                                                                ? mailing.contacts[0].id
                                                                : null
                                                        )
                                                    }
                                                >
                                                    <DownloadIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Box sx={{ textDecoration: "underline" }}>
                                                <a
                                                    href={`https://www.laposte.fr/outils/suivre-vos-envois?code=${mailing?.contacts && mailing.contacts.length === 1
                                                        ? mailing.contacts[0].trackingNumber
                                                        : ""
                                                        }`}
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    {mailing?.contacts && mailing.contacts.length === 1
                                                        ? mailing.contacts[0].trackingNumber
                                                        : ""}
                                                </a>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center">
                                            {mailing?.contacts &&
                                                mailing.contacts.length === 1 &&
                                                mailing.contacts[0].mailevaRecipientProofId && (
                                                    <IconButton
                                                        onClick={() =>
                                                            getDepositProof(
                                                                mailing?.contacts &&
                                                                    mailing.contacts.length === 1
                                                                    ? mailing.contacts[0].id
                                                                    : null
                                                            )
                                                        }
                                                    >
                                                        <DownloadIcon />
                                                    </IconButton>
                                                )}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Button
                                                onClick={() => {
                                                    setOpenDetailsDialog(true);
                                                    setMailingToDetail(mailing);
                                                }}
                                                color="primary"
                                            >
                                                Détails
                                            </Button>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Button
                                                onClick={() => {
                                                    setOpenResendDialog(true);
                                                    setMailingToResend(mailing);
                                                }}
                                                color="primary"
                                            >
                                                Renvoyer
                                            </Button>
                                        </TableCell>

                                        <Dialog
                                            fullWidth
                                            maxWidth="lg"
                                            open={openResendDialog}
                                            onClose={handleCloseResendDialog}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby={
                                                "alert-dialog-description-" + mailing.id
                                            }
                                        >
                                            <DialogTitle id="alert-dialog-title">
                                                Renvoyer le document
                                            </DialogTitle>
                                            <DialogContent>
                                                <DialogContentText
                                                    id={
                                                        "alert-dialog-description-content-" + mailing.id
                                                    }
                                                    sx={{ color: "red" }}
                                                >
                                                    Veuillez vérifier le document avant de le renvoyer
                                                </DialogContentText>
                                                {mailingToResend && (
                                                    <ResiliationLetter
                                                        formFields={mailingToResend}
                                                        resiliationModel={
                                                            mailingToResend.resiliationModel
                                                        }
                                                        address={mailingToResend.contacts[0]}
                                                        containerId={`mailing-${mailingToResend.id}`}
                                                    />
                                                )}
                                            </DialogContent>
                                            <DialogActions>
                                                <Button
                                                    onClick={handleCloseResendDialog}
                                                    color="primary"
                                                >
                                                    Annuler
                                                </Button>
                                                <Button
                                                    onClick={() =>
                                                        downloadPdf(
                                                            `mailing-${mailingToResend.id}.pdf`,
                                                            `mailing-${mailingToResend.id}`
                                                        )
                                                    }
                                                    color="primary"
                                                    autoFocus
                                                >
                                                    Télécharger
                                                </Button>
                                                <Button
                                                    onClick={() =>
                                                        resendDocument(
                                                            mailingToResend.id,
                                                            `mailing-${mailingToResend.id}`
                                                        )
                                                    }
                                                    color="primary"
                                                    autoFocus
                                                >
                                                    Renvoyer
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {mailingToDetail != null && (
                        <SendingDetailsDialog
                            mailing={mailingToDetail}
                            open={openDetailsDialog}
                            handleClose={() => {
                                setOpenDetailsDialog(false);
                                setMailingToDetail(null);
                            }}
                        />
                    )}
                </Box>
            )}
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleCloseSnackBar}
                message={snackContent}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                action={
                    <Fragment>
                        <Button
                            color="secondary"
                            size="small"
                            onClick={handleCloseSnackBar}
                        >
                            OK
                        </Button>
                    </Fragment>
                }
            />
        </div>
    );
}

export const ClientShow = (props) => (
    <MyShow {...props}>
        <SimpleShowLayout>
            <TextField source="uid" />
            <TextField source="name" />
            <EmailField source="email" />
        </SimpleShowLayout>
    </MyShow>
);



function StatusShipment({ item }) {
    const [status, setStatus] = useState("send");
    let label = "";
    let color = "";
    let backgroundColor = "";

    useState(() => {
        let isSend = true;

        if (item != null && item.contacts != null && item.contacts.length > 0) {
            item.contacts.forEach(c => {
                if (c.mailevaRecipientContentProofId == null || c.mailevaRecipientProofId == null) {
                    isSend = false;
                }
            })
            if (!item.mailevaSendingId) {
                setStatus("not send")
            }
            else if (!isSend) {
                setStatus("in progress")
            }

        }
    }, [item])

    if (status === "send") {
        label = "Envoyé";
        color = "#3bbe4f";
        backgroundColor = "#d2f0d7";
    } else if (status === "in progress") {
        label = "En cours";
        color = "#fed13a";
        backgroundColor = "#fff4d6";
    } else if (status === "not send") {
        label = "Erreur";
        color = "#AA3939";
        backgroundColor = "#FFAAAA";
    } else if (status === "to be processed") {
        label = "Traité";
        color = "#dc5856";
        backgroundColor = "#f7dddd";
    }

    return (
        <>
            <Chip
                label={label}
                sx={{
                    px: 2,
                    color: { color },
                    backgroundColor: { backgroundColor, width: "114px" },
                }}
            />
        </>
    );
}

// type of shipment
function TypeShipment({ item }) {
    let type = item?.resiliationModel ? "MyResil" : "LREL";
    let iconText = "";
    // let css = { display: "flex", alignItems: "flex-end" };

    if (type === "MyResil") {
        iconText = (
            <Box>
                <FileOpenIcon sx={{ mr: 1 }} /> MyResil
            </Box>
        );
    } else if (type === "LREL") {
        iconText = (
            <Box>
                <NoteAltIcon sx={{ mr: 1 }} /> LREL
            </Box>
        );
    }

    return (
        <>
            <Box>{iconText}</Box>
        </>
    );
}

export default function TooltipQuestionMark(props) {
    return (
        <Tooltip title={props.tooltip} enterTouchDelay={0} leaveTouchDelay={5000}>
            <Stack sx={{ backgroundColor: "blue", borderRadius: "50%", width: "16px", height: "16px", marginLeft: "6px", cursor: "pointer" }}>
                <Typography sx={{ fontSize: "12px!important", textAlign: "center", color: "#FFFFFF" }}>
                    ?
                </Typography>
            </Stack>
        </Tooltip>
    )
}